export default "__VITE_ASSET__DXo1l6qF__"